import {
    ClaimsSchemaFieldBooleanValue,
    ClaimsSchemaFieldDateTimeValue,
    ClaimsSchemaFieldDateValue,
    ClaimsSchemaFieldFileValue,
    ClaimsSchemaFieldLinkValue,
    ClaimsSchemaFieldNumberValue,
    ClaimsSchemaFieldStringValue,
    ClaimsSchemaFieldStructValue,
    CredentialClaimValues,
} from '../../api';
import type { UpdatePayload, UserUpdateClaims } from '../types';

export type Claims = Record<string, any>;

export type CredentialBlob = Blob;

export type DraftDataDescriptor = {
    meta?: {
        subject?: string;
        validUntil?: Date;
    };
    values?: CredentialClaimValues;
};

export type DraftMetadata = {
    subject?: string;
    validUntil?: Date;
};

export type CredentialMetadata = DraftMetadata & {
    id: string;
    issuer: string;
    validFrom?: Date;
    holder?: string;
};

export type CredentialClaims = Record<string, unknown>;

export type CredentialSchema = Record<string, unknown>;

export type Flavor<T = CredentialClaims> = {
    getClaims: (blob: CredentialBlob) => Promise<T>;
    getMetadata: (blob: CredentialBlob) => Promise<CredentialMetadata>;
    getSchema: (blob: CredentialBlob) => Promise<CredentialSchema | undefined>;
};

export type DocumentFlavor = Flavor & {
    kind: string;
    isOfFlavor: (blob: CredentialBlob) => Promise<boolean>;
};

export type UpdatePayloadWithClaims<T extends Claims> = UpdatePayload & {
    claims?: UserUpdateClaims<T>;
    metadata?: DraftMetadata;
};

export type Json = Record<string, any>;

export type ClaimsSchemaFieldValue =
    | ClaimsSchemaFieldBooleanValue
    | ClaimsSchemaFieldDateTimeValue
    | ClaimsSchemaFieldDateValue
    | ClaimsSchemaFieldFileValue
    | ClaimsSchemaFieldLinkValue
    | ClaimsSchemaFieldNumberValue
    | ClaimsSchemaFieldStringValue
    | ClaimsSchemaFieldStructValue;
